import { IconX } from "@tabler/icons-react";
import type * as React from "react";
import { cn } from "@/lib/cn";

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card"
      className={cn(
        "tw-flex tw-flex-col tw-gap-8 tw-w-[512px] tw-rounded-xl tw-border tw-bg-white tw-py-6 tw-text-blue tw-shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "@container/card-header tw-has-data-[slot=card-action]:tw-grid-cols-[1fr_auto] [.border-b]:tw-pb-6 tw-grid tw-auto-rows-min tw-grid-rows-[auto_auto] tw-items-start tw-gap-2 tw-px-6",
        className,
      )}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn(
        "tw-font-sans tw-text-lg tw-font-semibold tw-text-blue",
        className,
      )}
      {...props}
    />
  );
}

function CardCloseButton({
  className,
  ...props
}: React.ComponentProps<"button">) {
  return (
    <button
      data-slot="card-close-button"
      className={cn(
        "tw-group/card-close tw-size-4 tw-text-blue-500 tw-outline-none",
        className,
      )}
      {...props}
    >
      <IconX className="tw-size-4 tw-text-blue-500 tw-transition-colors group-hover/card-close:tw-text-blue" />
    </button>
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("tw-text-muted-foreground tw-text-sm", className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "tw-col-start-2 tw-row-span-2 tw-row-start-1 tw-self-start tw-justify-self-end",
        className,
      )}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("tw-px-6", className)}
      {...props}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn(
        "[.border-t]:tw-pt-6 tw-flex tw-items-center tw-px-6",
        className,
      )}
      {...props}
    />
  );
}

export {
  Card,
  CardAction,
  CardCloseButton,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
};
